import {offerPriceAsc, offerPriceDesc, priceAsc, priceDesc} from '~/utils/sort-helpers'

export const sortOffersInsideProduct = {
    priceAsc: product => {
        product.offers?.sort(offerPriceAsc)
    },
    priceDesc: product => {
        product.offers?.sort(offerPriceDesc)
    },
    dateAsc: product => {
        sortOffersInsideProduct.priceAsc(product)
        product.offers?.sort((a, b) => {
            return new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
        })
    },
}

export default function (products, sortFnName) {
    const minDate = product =>
        Math.min.apply(
            null,
            product.offers.map(offer => new Date(offer.startDate))
        )
    const sortFn = {
        priceAsc,
        priceDesc,
        dateAsc: (product1, product2) => {
            if (minDate(product1) !== minDate(product2)) {
                return minDate(product1) - minDate(product2)
            } else {
                return sortFn.priceAsc(product1, product2)
            }
        },
    }

    products.forEach(product => {
        sortOffersInsideProduct[sortFnName]?.(product)
    })

    return products.concat().sort((product1, product2) => sortFn[sortFnName](product1, product2))
}
